/* eslint-disable quotes */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import advSearchState from 'Stores/advSearch';
import { userDetail } from 'Stores/userDetail';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as AddToListIcon } from 'Assets/svg/add-to-list.svg';
import { ReactComponent as DownloadIcon } from 'Assets/svg/download.svg';
import { ReactComponent as ContactPhoneIcon } from 'Assets/svg/contact-phone.svg';
import { ReactComponent as ContactEmailIcon } from 'Assets/svg/contact-email.svg';
import { ReactComponent as SavedSearchIllustration } from 'Assets/svg/savedSearch.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import SaveSearchBannerBg from 'Assets/png/save-search-banner.png';
import ContactName from 'Components/common/ContactList/contactName';
import ContactCompany from 'Components/common/ContactList/contactCompany';
import ContactEmailPhone from 'Components/common/ContactList/contactEmailPhone';
import CheckBox from 'Components/common/CheckBox';
import ContactIndustry from 'Components/common/ContactList/ContactIndustry';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import { commonUpgradePopupState } from 'Components/common/commonUpgradePopup';
import ToolTipWithIcon from 'Components/common/ToolTipWithIcon';
import myLeadsState from 'Stores/myLeads';
import { addToListWithOptionsState } from '../AddToListWithOptions';

const {
  SEOCookieQueryMapping,
  UPGRADE_TRIGGERS,
  MX_AS_EVENTS,
  EXPORT_SOURCE,
} = CONSTANTS;

const { ADVANCED_SEARCH } = EXPORT_SOURCE;

const ContactListLoadingPlaceHolder = () => {
  return (
    <>
      <div className="contact-list-wrap">
        {Array(15)
          .fill()
          .map((item, index) => {
            return (
              <div className="contact-item" key={index}>
                <div className="contact-check-box-wrap">
                  <div className="common-check-box linear-background" />
                </div>
                <div className="contact-name">
                  <div className="name linear-background" />
                  <div className="title linear-background" />
                  <div className="contact-address-info linear-background" />
                </div>
                <div className="contact-info ">
                  <div className="contact-email">
                    <div className="info-icon linear-background" />
                    <div className="contact-email-copy-wrap linear-background" />
                  </div>
                  <div className="contact-email">
                    <div className="info-icon linear-background" />
                    <div className="contact-email-copy-wrap linear-background" />
                  </div>
                </div>
                <div className="contact-action">
                  <div className="contact-action-btn-wrap">
                    <div className="contact-action-btn view-contact linear-background" />
                    <div className="contact-action-btn view-contact linear-background" />
                  </div>
                </div>
                <div className="company-name">
                  <div className="name linear-background" />
                  <div className="company-address-info linear-background" />
                  <div className="company-phone-info linear-background" />
                </div>
                <div className="company-name industry">
                  <div className="name linear-background" />
                  <div className="company-address-info linear-background" />
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

const ContactList = observer(props => {
  const {
    data,
    allChecked,
    contactId,
    setContactId,
    savedSearchId,
    setShowPopup: setShowSavedSearchPopup,
    isListLoading = false,
    history,
  } = props;

  const [addToListOffset, setAddToListOffset] = React.useState({
    top: 0,
    left: 0,
  });

  const { featureFlags, userInfo, isFreeTrial } = userDetail;
  const { LOCATION_PREFERENCE = false, LEAD_BUILDER = false } = featureFlags;

  const purchaseContact = (e, id) => {
    Utils.totangoTrack(
      CONSTANTS.TOTANGO.EVENTS.PURCHASE,
      CONSTANTS.TOTANGO.MODULES.LB,
    );
    if (userInfo.userStatus === 0)
      if (!Utils.checkIsLeadBuilderEnabled()) {
        Utils.mixpanelTrack(MX_AS_EVENTS.AS_PAYWALL_PRICING_POPUP, {
          btnSource: 'AS - LB Disabled',
        });
        commonUpgradePopupState.setShowUpgradePopup(
          UPGRADE_TRIGGERS.COMMON_PLATFORM_FEATURE,
        );
      } else if (userInfo.lbCredits <= 0 && Utils.isFreeTrialPlan()) {
        userDetail.setShowUpgradeCreditPopup(true);
      } else if (
        !Utils.isPaygPlan() &&
        ((!Utils.isCreditBasedSubscription() && userInfo.views <= 0) ||
          (Utils.isCreditBasedSubscription() &&
            (userInfo.lbCredits <= 0 || !Utils.isCreditsWithinMonthlyLimit())))
      ) {
        if (
          userInfo.memberSubscription !== null &&
          userInfo.memberSubscription !== undefined
        ) {
          Utils.showCreditExpiredPopup('views');
        } else {
          Utils.mixpanelTrack(MX_AS_EVENTS.AS_VIEWS_EXPIRED, {});
          Utils.mixpanelTrack(MX_AS_EVENTS.AS_PAYWALL_PRICING_POPUP, {
            btnSource: 'AS - Views',
          });
          Utils.showUserPricingPopup(true, 'views', false);
        }
      } else {
        const callback = async (callbackData = { lessCredits: false }) => {
          if (callbackData.lessCredits) {
            confirmationPopupState.setPopupValues({
              title: "You've run out of email credits",
              content:
                'To proceed with the purchase, either increase your credit balance',
              actionBtnText: 'Buy more credits',
              needCancelBtn: false,
              customClassName: 'credit-expired-popup',
              callback: () => {
                history.push(CONSTANTS.PAGE_PATH_MAP.BUY_MORE_CREDITS);
              },
            });
            confirmationPopupState.setShowPopup(true);
          } else {
            advSearchState.purchaseEmail(id);
          }
        };
        Utils.checkUserHasEnoughCredits(1, 'view contact', callback);
      }
    else Utils.showEmailConfirmationPopup(userInfo.email);
  };

  const showBuyMorePhoneCreditsPopup = () => {
    confirmationPopupState.setPopupValues({
      title: "You've run out of phone credits",
      content: 'To proceed with the purchase, increase your credit balance',
      actionBtnText: 'Buy more credits',
      needCancelBtn: false,
      customClassName: 'phone-credit-expired-popup',
      callback: () => {
        Utils.mixpanelTrack(
          CONSTANTS.MOBILE_NUMBER_EVENTS.PHONE_CREDITS_EXPIRED_BUY_MORE_CLICKED,
        );
        history.push(CONSTANTS.PAGE_PATH_MAP.BUY_MORE_CREDITS);
      },
    });
    confirmationPopupState.setShowPopup(true);
    Utils.mixpanelTrack(
      CONSTANTS.MOBILE_NUMBER_EVENTS.PHONE_CREDITS_EXPIRED_POPUP_SHOWN,
    );
  };

  const purchaseMobile = id => {
    if (!Utils.checkIsLeadBuilderEnabled()) {
      Utils.mixpanelTrack(MX_AS_EVENTS.AS_PAYWALL_PRICING_POPUP, {
        btnSource: 'AS - LB Disabled',
      });
      commonUpgradePopupState.setShowUpgradePopup(
        UPGRADE_TRIGGERS.COMMON_PLATFORM_FEATURE,
      );
    } else if (
      !Utils.isLBPaidSubscription() &&
      !(
        Utils.isEnterpriseFreeTrialPlan() &&
        userDetail.userInfo.phoneVendorPurchaseEnabled
      )
    ) {
      Utils.mixpanelTrack(
        CONSTANTS.MOBILE_NUMBER_EVENTS.MOBILE_NUMBER_UPGRADE_POPUP_SHOWN,
      );
      commonUpgradePopupState.setShowUpgradePopup(
        CONSTANTS.UPGRADE_TRIGGERS.PURCHASE_PHONE,
      );
    } else if (
      Utils.isPaygPlan() &&
      userDetail.userInfo.phoneCreditsRemaining === 0
    ) {
      showBuyMorePhoneCreditsPopup();
    } else {
      const callback = (callbackData = { lessCredits: false }) => {
        if (callbackData.lessCredits) showBuyMorePhoneCreditsPopup();
        else if (userDetail.userInfo.phoneCreditsRemaining === 0)
          advSearchState.showPhoneCreditsExhaustedPopup();
        else advSearchState.purchaseMobileNumber(id);
      };

      Utils.checkUserHasEnoughCredits(1, 'request mobile', callback, 'phone');
    }
  };

  const handleMaskedContactInfoClick = (e, id) => {
    Utils.mixpanelTrack(MX_AS_EVENTS.AS_PHONE_SCORE_LOCK_CLICK, {
      contactId: id,
      LEAD_BUILDER,
    });
    purchaseContact(e, id);
  };

  const downloadContact = (item, id) => {
    Utils.mixpanelTrack(MX_AS_EVENTS.AS_DOWNLOAD_CLICK, {});

    if (!Utils.checkIsCSVExportEnabled(ADVANCED_SEARCH))
      commonUpgradePopupState.setShowUpgradePopup(
        UPGRADE_TRIGGERS.SINGLE_CSV_EXPORT,
      );
    else advSearchState.exportAsCSV({ contactIds: [id] });
  };

  const contactSelection = (e, index) => {
    if (
      advSearchState.selectedAllContactAcrossPage ||
      advSearchState.selectedContactFromRange
    ) {
      const deselectCallback = () => {
        advSearchState.updateSelectedBulkContactAll(true);
      };
      confirmationPopupState.setPopupValues({
        title: 'Unable to deselect',
        content:
          'Unable to deselect individual items while using "Select all or Range selection". To deselect an item, clear the selection and select items individually.',
        actionBtnText: 'Clear selection',
        callback: deselectCallback,
      });
      confirmationPopupState.setShowPopup(true);
    } else {
      advSearchState.updateSelectedBulkContactIds(index);
    }
  };

  const addSingleItemToList = item => {
    const { memberContactId } = item;

    addToListWithOptionsState.setAddToListOptions({
      isSingleContactAddToList: true,
      saveAction: async dataProps => {
        const { listId, listName, callback } = dataProps;
        await myLeadsState.addToList({
          listId,
          listName,
          memberContactIds: [memberContactId],
        });
        callback();
      },
    });
    addToListWithOptionsState.setShowListPopup(true);
  };

  const listView = data.map((item, index) => {
    const seoContactId = Utils.getCookie(SEOCookieQueryMapping.contactId);
    let seoPathVal = false;
    seoPathVal = seoContactId && seoContactId === item.id;
    const contactName = `${item.firstName}${
      item.lastName !== null ? ` ${item.lastName}` : ''
    }`;

    return (
      <div
        className={`contact-item-wrap ${
          advSearchState.singlePurchaseLoaderIds.includes(item.id)
            ? 'disable'
            : ''
        }`}
        key={item.id}
      >
        <div
          className={`contact-item${
            seoPathVal && index === 0 && advSearchState.currentPage === 0
              ? ' seoPageContact'
              : ''
          }`}
        >
          <div className="contact-check-box-wrap">
            <CheckBox
              dymamicClass={item.checked ? 'selected' : ''}
              onClick={e => contactSelection(e, index)}
            />
          </div>

          <ContactName
            name={contactName}
            title={item.title}
            facebookId={item.facebookId}
            twitterId={item.twitterId}
            linkedInId={item.linkedInId}
            cname={item.companyName}
            contactCity={item.contactCity}
            contactState={item.contactState}
            contactCountry={item.contactCountry}
            companyCountry={item.companyCountry}
            companyState={item.companyState}
            companyCity={item.companyCity}
            contactId={item.id}
            email={item.email}
            phoneNumberFromVendor={item.phoneNumberFromVendor}
            owned={item.owned}
            status={item.status}
            score={item.deliverability}
            purchaseContact={purchaseContact}
            LOCATION_PREFERENCE={LOCATION_PREFERENCE}
          />

          <ContactEmailPhone
            contactId={item.id}
            email={item.email}
            status={item.status}
            phoneNumberFromVendor={item.phoneNumberFromVendor}
            isDownloaded={item.owned}
            score={item.deliverability}
            currentPage="advSearch"
            purchaseContactFunc={handleMaskedContactInfoClick}
            purchaseMobile={purchaseMobile}
            isEmailValid={item.emailValid}
            showFindEmail={item.showFindEmail}
          />

          <div className="contact-action">
            {advSearchState.singlePurchaseLoaderIds.includes(item.id) ? (
              <span className="loader">
                <div className="load-wrapper">
                  <span className="load-text" />
                </div>
                <span>Processing</span>
                <ToolTipWithIcon>
                  {`It's taking a bit longer than usual. ${
                    advSearchState.singlePurchaseType === 'EMAIL'
                      ? 'We will add this contacts to your list once we verify this email'
                      : ''
                  }`}
                </ToolTipWithIcon>
              </span>
            ) : (
              <>
                {item.owned && (
                  <div className="contact-action-btn-wrap contact-action-multi-btn-wrap">
                    <div
                      className="contact-action-btn download"
                      onClick={() => downloadContact(item, item.id)}
                    >
                      <DownloadIcon className="svg-icon" />
                      <div className="copy-tooltip-wrap">
                        <span className="copy-tooltip">Download</span>
                        <span className="sharp-point" />
                      </div>
                    </div>
                    <div
                      className={`contact-action-btn add-to-list ${
                        index === 0 ? ' add-to-list-first-contact' : ''
                      }`}
                      onClick={() => addSingleItemToList(item)}
                      data-id={item.id}
                    >
                      <AddToListIcon className="svg-icon" />
                      <div className="copy-tooltip-wrap">
                        <span className="copy-tooltip">Add to List</span>
                        <span className="sharp-point" />
                      </div>
                    </div>
                  </div>
                )}
                {item.showFindEmail && item.email?.startsWith('*') && (
                  <div className="contact-action-btn-wrap">
                    <div
                      className="contact-action-btn view-contact viewContactSingleLB"
                      onClick={() => purchaseContact(this, item.id)}
                    >
                      <ContactEmailIcon />
                      Find Email
                    </div>
                  </div>
                )}
                {Utils.isCreditBasedSubscription() &&
                  (item.phoneNumberFromVendor === null ||
                    item.phoneNumberFromVendor === undefined) &&
                  (!userDetail.userInfo.phoneVendorPurchaseEnabled &&
                  Utils.isLBPaidSubscription() ? (
                    <ToolTipWithIcon
                      callback={() => {
                        Utils.mixpanelTrack(
                          CONSTANTS.MOBILE_NUMBER_EVENTS
                            .MOBILE_NUMBER_UPGRADE_POPUP_SHOWN,
                        );
                      }}
                      className="mobile-number-locked"
                      Icon={
                        <button
                          type="button"
                          className="find-phone"
                          disabled={
                            !userDetail.userInfo.phoneVendorPurchaseEnabled &&
                            Utils.isLBPaidSubscription()
                          }
                        >
                          <ContactPhoneIcon />
                          Request Mobile
                        </button>
                      }
                    >
                      Mobile Numbers are not available in your current plan.
                      Please upgrade your plan to get access.
                      <button
                        type="button"
                        onClick={() => {
                          advSearchState.notifyMobileNumberInterest();
                          window.open(
                            CONSTANTS.PAGE_PATH_MAP.PRICING,
                            '_blank',
                          );
                        }}
                      >
                        Upgrade Now
                      </button>
                    </ToolTipWithIcon>
                  ) : (
                    <button
                      type="button"
                      className="find-phone"
                      onClick={() => purchaseMobile(item.id)}
                    >
                      <ContactPhoneIcon />
                      Request Mobile
                    </button>
                  ))}
              </>
            )}
          </div>

          <ContactCompany
            cname={item.companyName}
            companyCountry={item.companyCountry}
            companyState={item.companyState}
            companyCity={item.companyCity}
            companyLogo={item.logo}
            companyId={item.companyId}
            companyPhone={item.companyPhone}
            showLogo
          />
          <ContactIndustry
            industry={item.industry}
            employeeCount={item.employeeCount}
            revenue={item.revenue}
          />
        </div>
      </div>
    );
  });

  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const isToShowBanner =
      (Utils.getLocalStorage('saved-search-banner') === null ||
        advSearchState.searchResultCount < 50) &&
      !savedSearchId;
    if (isToShowBanner)
      Utils.mixpanelTrack(CONSTANTS.MX_SAVED_SEARCH_BANNER.SHOWN, {
        resultsCount: advSearchState.searchResultCount,
      });
    setShowBanner(isToShowBanner);
  }, [savedSearchId, advSearchState.searchResultCount]);

  return isListLoading ? (
    <div className="contact-list contact-list-loading-placeholder">
      <ContactListLoadingPlaceHolder />
    </div>
  ) : (
    <div className="contact-list">
      {showBanner && (
        <div className="saved-search-banner">
          <img src={SaveSearchBannerBg} alt="gradient background" />
          <div className="icon-with-text">
            <SavedSearchIllustration className="saved-search-icon" />
            <div className="text">
              Want more leads? Create Alerts and get notified when we find more
              leads for you.
            </div>
          </div>
          <div className="button-wrapper">
            <button
              type="button"
              onClick={() => {
                Utils.setLocalStorage('saved-search-banner', true);
                setShowBanner(false);
                setShowSavedSearchPopup(true);
                Utils.mixpanelTrack(
                  CONSTANTS.MX_SAVED_SEARCH_BANNER.SAVE_SEARCH_CLICKED,
                  { resultsCount: advSearchState.searchResultCount },
                );
              }}
            >
              Create Alert
            </button>
          </div>
          <CloseIcon
            className="close-icon"
            onClick={() => {
              Utils.setLocalStorage('saved-search-banner', true);
              setShowBanner(false);
              Utils.mixpanelTrack(CONSTANTS.MX_SAVED_SEARCH_BANNER.CLOSED, {
                resultsCount: advSearchState.searchResultCount,
              });
            }}
          />
        </div>
      )}
      <div className="contact-list-wrap">{listView}</div>
    </div>
  );
});

export { ContactList, ContactListLoadingPlaceHolder };
export default ContactList;
